<template>
  <div>
    <button
      :disabled="loading"
      @click="showModal"
      class="btn btn-sm btn-icon btn-info ml-auto"
    >
      <i v-show="loading" class="fas fa-spinner fa-spin mr-1"></i>
      <i v-show="!loading" class="fas fa-money-bill-wave mr-1"></i>
      Añadir Pago
    </button>
    <!-- Modal -->
    <b-modal
      ref="modal-cfdi-acciones"
      hide-footer
      title="Acciones"
      body-class="border-top"
      header-class="py-2 align-items-baseline"
      size="lg"
    >
      <template #modal-title>
        <h3>Acciones</h3>
      </template>
      <div class="row">
        <div class="col">
          <div class="form-group">
            <label>Serie</label>
            <input
              type="text"
              class="form-control"
              v-model="modal.data.serie"
            />
          </div>
          <div class="form-group">
            <label>Folio</label>
            <input
              type="text"
              class="form-control"
              v-model="modal.data.folio"
            />
          </div>
          <div class="form-group">
            <label>Fecha</label>
            <input
              type="text"
              class="form-control"
              v-model="modal.data.fecha"
            />
          </div>
          <hr />
          <div class="form-group">
            <label>Emisor</label>
            <input
              type="text"
              class="form-control"
              v-model="modal.data.emisor.name"
            />
          </div>
          <div class="form-group">
            <label>Emisor</label>
            <input
              type="text"
              class="form-control"
              v-model="modal.data.receptor.name"
            />
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
export default {
  props: {
    uuid: {
      type: String,
      required: true,
    },
    total: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      payments: [],
      modal: {
        data: {
          serie: "",
          folio: "",
          fecha: "",
          emisor: {
            name: "",
          },
          receptor: {
            name: " ",
          },
        },
      },
    };
  },
  mounted() {
    this.fetchPayments(this.uuid);
  },
  methods: {
    showModal() {
      this.$refs["modal-cfdi-acciones"].show();
    },
    async fetchPayments(uuid) {
      try {
        this.loading = true;

        response = await this.$api.get(
          `/facturacion/cfdi-global/${uuid}/payments`
        );

        this.payments = response.data;
      } catch (error) {
        this.$notiflix.Notify.failure(
          error.response.data.errors || error.response.data
        );
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
